import { render } from "./cronlogs.vue?vue&type=template&id=53368748"
import script from "./cronlogs.vue?vue&type=script&lang=js"
export * from "./cronlogs.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__